import { Page, TestDefinition } from "../../../api";
import { createContext } from "react";

export type PageContextType = {
  pages: Page[];
  setPages: (pages: Page[]) => void;
  tests: TestDefinition[];
  setTests: (tests: TestDefinition[]) => void;
};

export const PageContext = createContext<PageContextType>({} as PageContextType);
